export const getSellThruField = (field: string) => {
  return field.replace('Sob', '')
}
